// extracted by mini-css-extract-plugin
export default {"search-bar":"SearchBar_search-bar__-uGiU","search-bar-input":"SearchBar_search-bar-input__8akXd"};